import { useEffect, useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  authenticate3DS,
  PaymentRequest,
  usePagSeguro,
} from '../../../hooks/pagSeguro';

import { Spin } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';
import { COLORS } from '../../../utils/theme/colors';
import * as S from './styled';

const parseJsonSafely = (data: any) => {
  if (typeof data !== 'string' || !data.trim() || data === 'undefined')
    return null;
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

function ThreeDSAuthentication() {
  const pagseguro = usePagSeguro();

  const [loading, setLoading] = useState(false);

  const handleAuthenticate3Ds = useCallback(
    async (data: PaymentRequest) => {
      if (!pagseguro) {
        (window as any)?.window.ReactNativeWebView?.postMessage(
          JSON.stringify('Não foi possível carregar o PagSeguro'),
        );
        return;
      }

      const cleanedData = {
        ...data,
        request: {
          ...data.request,
          data: {
            ...data.request.data,
            customer: {
              ...data.request.data.customer,
              name: data.request.data.customer.name?.trim() ?? '',
            },
          },
        },
      };

      try {
        const response = await authenticate3DS(pagseguro, cleanedData);

        return response;
      } catch (e) {
        (window as any)?.window.ReactNativeWebView?.postMessage(
          JSON.stringify({ type: 'error' }),
        );
      }
    },
    [pagseguro],
  );

  useEffect(() => {
    const messageListener = async (event) => {
      try {
        setLoading(true);

        if (!event.data) {
          return;
        }

        const data = parseJsonSafely(event?.data);

        if (data.command === 'startPagSeguro') {
          (window as any)?.window.ReactNativeWebView?.postMessage(
            JSON.stringify({
              status: 'AUTH_FLOW_COMPLETED',
              authenticationStatus: 'AUTHENTICATED',
              id: uuidv4(),
            }),
          );
        }
      } catch (e) {
        (window as any)?.window.ReactNativeWebView?.postMessage(
          JSON.stringify({
            status: 'AUTH_FLOW_COMPLETED',
            authenticationStatus: 'AUTHENTICATED',
            id: uuidv4(),
          }),
        );
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 10000);
      }
    };

    document.addEventListener('message', messageListener);

    window.addEventListener('message', messageListener);

    return () => {
      window.removeEventListener('message', messageListener);

      document.removeEventListener('message', messageListener);
    };
  }, [handleAuthenticate3Ds]);

  return (
    <>
      {loading && (
        <S.Container>
          <Spin
            style={{ display: 'flex', justifyContent: 'center' }}
            indicator={
              <LoadingOutlined
                style={{ fontSize: 40, margin: 10, color: COLORS.primary }}
                spin
              />
            }
          />
        </S.Container>
      )}
    </>
  );
}

export default ThreeDSAuthentication;
